import EditLinkModal from './EditLinkModal';

export default EditLinkModal;
